let worker: Worker | null = null;
const pending = new Map<string, (result: any) => void>();
let counter = 0;

const getWorker = (): Worker => {
  if (!worker) {
    worker = new Worker(new URL("../workers/reportTable.worker.ts", import.meta.url));
    worker.onmessage = (event: MessageEvent) => {
      const { id, result } = event.data as { id: string; result: any };
      const resolve = pending.get(id);
      if (resolve) {
        pending.delete(id);
        resolve(result);
      }
    };
  }
  return worker;
};

export const runReportAggregation = (
  kind: "temp" | "operation" | "power" | "iot",
  payload: { rawResult: any[]; dateTimeStr: string; unit: string }
): Promise<any> => {
  const id = `${Date.now()}-${counter++}`;
  return new Promise((resolve) => {
    pending.set(id, resolve);
    getWorker().postMessage({ id, kind, payload });
  });
};
